import { Area, Drawer } from '../types';
import { SCALE } from './constants';

export const CONTAINER_WIDTH = Math.round(600 * SCALE);
export const CONTAINER_HEIGHT = Math.round(600 * SCALE);
export const CONTAINER_PADDING = Math.round(14 * SCALE);

export class DebugMenuContainerDrawer implements Drawer {
    private area: Area;

    constructor(area: Area) {
        this.area = area;
    }

    draw(ctx: CanvasRenderingContext2D) {
        ctx.beginPath();
        ctx.fillStyle = '#000';
        ctx.fillRect(this.area.x, this.area.y, this.area.width, this.area.height);
    }
}
